import i18n from "i18next";

export function translateHealthCareProfessionalType(type: string): string {
  const keyMap: Record<string, string> = {
    therapist: i18n.t("patients.roles.therapist"),
    patient: i18n.t("patients.roles.patient"),
    orthopedist: i18n.t("patients.roles.orthopedist"),
  };

  return keyMap[type] || type;
}
